import React from 'react';
import { useParams } from 'react-router-dom';
import { FamilyTree } from '@/components/tree';
import { InvalidLink } from '../components/InvalidLink';
import { useSharedLink } from '../hooks/useSharedLink';

export function SharedView() {
  const { token } = useParams();
  const { error, isValid } = useSharedLink(token, 'view');

  if (!isValid) {
    return <InvalidLink message={error || 'رابط غير صالح'} />;
  }

  return (
    <div className="h-full">
      <FamilyTree />
    </div>
  );
}